import { render, staticRenderFns } from "./ContainerHeader.vue?vue&type=template&id=90b8388a&"
import script from "./ContainerHeader.vue?vue&type=script&lang=js&"
export * from "./ContainerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContainerHeader.vue?vue&type=style&index=0&id=90b8388a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports